import { Menu, X } from 'lucide-react';
import ProfileMenuButton from '../../../components/commoncomponents/ProfileMenuButton';

function AdminHeader({
  user,
  selectedBusiness,
  onLogout,
  onOpenProfile,
  onToggleSidebar,
  isSidebarOpen,
}) {
  const accessLabel = user?.user_type === 1 ? 'admin' : 'user';
  const companyName = 'RCM VENTURES';
  const currentBusinessName = selectedBusiness?.name || '';

  return (
    <header className="rounded-[1.35rem] border border-[#dfd1c4] bg-[linear-gradient(135deg,rgba(255,255,255,0.98),rgba(244,236,228,0.98))] px-3 py-3 shadow-[0_20px_42px_rgba(69,48,33,0.11)] backdrop-blur-sm sm:rounded-[1.75rem] sm:px-5 sm:py-4 lg:min-h-[108px] lg:px-6 lg:py-5">
      <div className="flex items-start justify-between gap-2.5 sm:gap-4">
        <div className="flex min-w-0 items-start gap-2.5 sm:gap-3">
          <button
            aria-expanded={isSidebarOpen}
            aria-label={isSidebarOpen ? 'Close navigation menu' : 'Open navigation menu'}
            className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-[1rem] border border-[#e7ddd3] bg-white text-[#5b4535] shadow-[0_10px_22px_rgba(69,48,33,0.08)] transition hover:border-[#d8cdbf] hover:bg-[#fcf8f4] sm:h-11 sm:w-11 sm:rounded-2xl lg:hidden"
            onClick={onToggleSidebar}
            type="button"
          >
            {isSidebarOpen ? <X className="h-4.5 w-4.5 sm:h-5 sm:w-5" /> : <Menu className="h-4.5 w-4.5 sm:h-5 sm:w-5" />}
          </button>

          <div className="min-w-0">
            <p className="m-0 text-[11px] uppercase tracking-[0.14em] text-[#93857b] sm:text-sm">
              Logged in as {accessLabel}
            </p>
            <h1 className="mt-0.5 truncate text-lg font-semibold tracking-[-0.04em] text-[#111111] sm:mt-1 sm:text-2xl">
              {companyName}
            </h1>
            {currentBusinessName ? (
              <p className="mt-0.5 truncate text-[12px] text-[#8d7c6f] sm:mt-1 sm:text-sm">
                Current business: {currentBusinessName}
              </p>
            ) : null}
          </div>
        </div>

        <ProfileMenuButton user={user} onLogout={onLogout} onOpenProfile={onOpenProfile} />
      </div>

      <div className="mt-3 flex items-center gap-1.5 overflow-x-auto sm:mt-4 sm:gap-2 lg:hidden">
        <span className="inline-flex whitespace-nowrap rounded-full bg-[#f4ede6] px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.1em] text-[#6f5644] sm:px-3 sm:text-xs">
          Admin workspace
        </span>
        {currentBusinessName ? (
          <span className="inline-flex whitespace-nowrap rounded-full border border-[#e7ddd3] bg-white/80 px-2.5 py-1 text-[11px] font-medium text-[#7f6e61] sm:px-3 sm:text-xs">
            {currentBusinessName}
          </span>
        ) : null}
      </div>
    </header>
  );
}

export default AdminHeader;
